import React, { useState, useEffect, useRef } from "react";
import { connectStateResults } from "react-instantsearch-dom";
import { SearchState } from "react-instantsearch-core";
import DestinationFilter from "./Filters/DestinationFilter";
import DepartureDateFilter from "./Filters/DepartureDateFilter";
import DurationFilter from "./Filters/DurationFilter";
import ShipFilter from "./Filters/ShipFilter";
import PromoFilter from "./Filters/PromoFilter";

const useHandleComponentVisibility = (initialIsVisible) => {
  const [visibleComponent, setVisibleComponent] = useState(initialIsVisible);
  const ref = useRef<HTMLDivElement>(null);

  const toggleVisibleComponent = (filterName, event) => {
    event.preventDefault();
    if (visibleComponent == filterName) setVisibleComponent(null);
    else setVisibleComponent(filterName);
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setVisibleComponent(false);
    }
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return {
    ref,
    visibleComponent,
    setVisibleComponent,
    toggleVisibleComponent
  };
};

export interface ExpandableFiltersProps {
  searchState: SearchState;
  className?: string;
  showShipFilter?: boolean;
  showDestinationFilter?: boolean;
  showDurationFilter?: boolean;
  showPromosFilter?: boolean;
}

const ExpandableFilters: React.FC<ExpandableFiltersProps> = ({
  searchState,
  className,
  showShipFilter,
  showDestinationFilter,
  showDurationFilter,
  showPromosFilter
}) => {
  const {
    ref,
    visibleComponent,
    toggleVisibleComponent
  } = useHandleComponentVisibility(null);

  return (
    <div className={className} ref={ref}>
      {showDestinationFilter && (
        <DestinationFilter
          expanded={visibleComponent == "destination"}
          searchState={searchState}
          toggleVisibleComponent={toggleVisibleComponent}
        />
      )}

      <DepartureDateFilter
        expanded={visibleComponent == "departure-date"}
        searchState={searchState}
        toggleVisibleComponent={toggleVisibleComponent}
      />

      {showDurationFilter && (
        <DurationFilter
          expanded={visibleComponent == "duration"}
          searchState={searchState}
          toggleVisibleComponent={toggleVisibleComponent}
        />
      )}

      {showShipFilter && (
        <ShipFilter
          expanded={visibleComponent == "ship"}
          searchState={searchState}
          toggleVisibleComponent={toggleVisibleComponent}
        />
      )}
      {showPromosFilter && (
        <PromoFilter
          expanded={visibleComponent == "promos"}
          searchState={searchState}
          toggleVisibleComponent={toggleVisibleComponent}
        />
      )}
    </div>
  );
};

export default connectStateResults(ExpandableFilters);
